<template>
  <v-container fluid>
    <v-toolbar dense flat>
      <v-btn-toggle v-model="computedSettings.viewMode" mandatory dense color="primary">
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn v-on="on" text value="single" small>
              <v-icon class="mr-2" color="primary">mdi-text-box</v-icon>
              Single Project
            </v-btn>
          </template>
          <span>Single project dashboard</span>
        </v-tooltip>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn v-on="on" text value="multiple" small>
              <v-icon class="mr-2" color="primary">mdi-text-box-multiple</v-icon>
              Multiple Projects
            </v-btn>
          </template>
          <span>Multiple projects dashboard</span>
        </v-tooltip>
      </v-btn-toggle>
    </v-toolbar>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: "OutputSSEToolbar",
  components: {},
  mixins: [],
  props: {
    settings: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    computedSettings: {
      get() {
        return this.settings;
      },
      set(val) {
        this.$emit("update:settings", val);
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
